import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
//Components
import { NotificationContainer } from "Components/Notifications";
import { NotificationManager } from 'Components/Notifications';
import { Modal, Button } from "@gpstrackit/gtc-react-controls";

//Actions
import {
    maintenanceDMSUDeleteMaintenanceServiceUnit,
    maintenanceDMSUGetMaintenanceServiceUnit,
    deleteMaintenanceServiceUnitLog,
    reset,
} from './redux/slice';

const DeleteMaintenanceService = (props) => {
    const { refresh, isComplete = false } = props;

    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const {
        maintenanceServiceUnit,
        loading,
        service,
        result,
        error,
        open,
    } = useSelector(state => state.maintenanceDeleteMaintenanceServiceUnitRedux);

    useEffect(() => {
        if (result) {
            NotificationManager.success(
                messages['maintenanceDeleteMaintenanceServiceUnit_success_message'],
                messages['success'],
                3000,
                null,
                null,
                'success'
            );
            refresh && refresh();
            dispatch(reset())
        }
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }));
        }
    }, [result, error, maintenanceServiceUnit])

    useEffect(() => {
        if (open && service) {
            dispatch(maintenanceDMSUGetMaintenanceServiceUnit({ id: service.id }))
        }
    }, [open])


    const handleDeleteSubmit = () => {
        if (isComplete) {
            dispatch(deleteMaintenanceServiceUnitLog({ id: service?.service?.idToDelete }))
        } else {
            dispatch(maintenanceDMSUDeleteMaintenanceServiceUnit({ id: maintenanceServiceUnit?.id }))
        }
    }

    const handleClose = () => {
        dispatch(reset());
    };

    return (
        <Modal
            title={`${messages['delete']} "${maintenanceServiceUnit?.service?.title || ""}"`}
            size="small"
            loading={loading}
            open={open}
            handleClose={handleClose}
            footer={(
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={(e) => handleDeleteSubmit()}
                        isDisabled={loading}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '0px 25px' }}>
                <p style={{ overflowWrap: 'anywhere' }}>
                    {`${messages['maintenanceDeleteMaintenanceServiceUnit_description']} "${maintenanceServiceUnit?.service?.title || "''"}"?`}
                </p>
            </div>
            <NotificationContainer />
        </Modal>
    )
}

export default DeleteMaintenanceService;
